module.exports = __webpack_public_path__ + "img/icon-elearning.41ba9916.svg";